export default __webpack_public_path__ + "_/images/marketplace/slot-sword-326435fd2c77bc80575754384a7c9a17d96f652ca62b7d84870158571afeecc6.png";